import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { DialogTitle } from 'Views/Page/Content/Modal/Components';
import LongRunningProcess
  from 'Views/Page/Content/Modal/Layouts/CreateYourPlanConfirmationStep/Layout/LongRunningProcess';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => DialogTitle,
    _customProps: { preventModalClose: true },
  }, overrideReadOnly)
  .nameOverride('loadingMessage', {
    _component: () => LongRunningProcess,
  }, overrideReadOnly);

export default metaOverrideSet;
